export const _LOAD_MODEL_ = 'Load:ServiceModel';
export const _RELOAD_TYPE_ = 'Reload:ServiceType';

export const _DELETE_SERVICE_ = 'Delete:Service';

export const _SAVE_SERVICE_SUCCESS_ = 'Save:ServiceSuccess';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  price: null,
};
